<template>
  <section class="sku-wrapper">
    <div class="title">{{ $t('wallet.select_amount') }}</div>
    <div class="sku-list flex-wrap">
      <CardItem
        v-for="item in skuList"
        :key="item.skuId"
        :item="item"
        :active="activeSku"
        @selectPackage="selectPackage(item)"
      />
    </div>
  </section>
</template>
<script>
  import CardItem from '../CardItem'

  export default {
    name: 'sku-info',
    props: ['skuList', 'activeSku'],
    components: {
      CardItem,
    },
    data() {
      return {}
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {
      selectPackage(item) {
        this.$emit('selectPackage', item)
      },
    },
  }
</script>

<style scoped lang="scss">
  .title {
    width: 100%;
    font-family: Manrope-Medium, Manrope;
    font-weight: 800;
    font-size: 42px;
    line-height: 57px;
    margin-bottom: 24px;
    text-transform: uppercase;
    color: #1c1c1c;
    word-break: break-all;
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
